import React, { Component } from "react";
import {
  PieChart,
  Pie,
  Legend,
  Tooltip,
  Cell,
  ResponsiveContainer
} from "recharts";
import Teams from "api/Teams";
import Styled from "components/pm/style";
import { view } from "@risingstack/react-easy-state";

const DIGITAL_MARKETING_LABEL = "Digital Marketing";
const TRADITIONAL_MARKETING_LABEL = "Traditional Marketing";

class DonutPMDecisionsPromotionalSpend extends Component {
  get total() {
    let sum = 0;

    Object.keys(this.props.products).forEach(product_id => {
      let product = this.props.products[product_id];

      if (
        product.player_traditional !== null &&
        product.traditional_spend_id > 0
      ) {
        sum += parseFloat(product.traditional_spend, 10);
      }

      if (product.player_digital !== null && product.digital_spend_id > 0) {
        sum += parseFloat(product.digital_spend, 10);
      }
    });

    return sum;
  }

  get traditionalMarketing() {
    let sum = 0;
    let total = this.total;

    if (total === 0) return 0;

    Object.keys(this.props.products).forEach(product_id => {
      let product = this.props.products[product_id];

      if (
        product.player_traditional !== null &&
        product.traditional_spend_id > 0
      ) {
        sum += parseFloat(product.traditional_spend, 10);
      }
    });

    return ((sum / total) * 100).toFixed(2);
  }

  get digitalMarketing() {
    let sum = 0;
    let total = this.total;

    if (total === 0) return 0;

    Object.keys(this.props.products).forEach(product_id => {
      let product = this.props.products[product_id];

      if (product.player_digital !== null && product.digital_spend_id > 0) {
        sum += parseFloat(product.digital_spend, 10);
      }
    });

    return ((sum / total) * 100).toFixed(2);
  }

  get data() {
    return [
      {
        name: TRADITIONAL_MARKETING_LABEL,
        value: parseFloat(this.traditionalMarketing, 10)
      },
      {
        name: DIGITAL_MARKETING_LABEL,
        value: parseFloat(this.digitalMarketing, 10)
      }
    ];
  }

  render() {

    return (
      <Styled.PS.Chart>
        <ResponsiveContainer width="100%" height={150} debounce={500}>
          <PieChart>
            <Legend
              iconType="circle"
              layout="vertical"
              align="right"
              verticalAlign="top"
            />
            <Tooltip formatter={val => `${val}%`} />
            <Pie
              data={this.data}
              cx={63}
              cy={78}
              innerRadius={27}
              outerRadius={63}
              labelLine={true}
              dataKey="value"
            >
              <Cell fill={Teams.traditionalMarketingColor()} />
              <Cell fill={Teams.digitalMarketingColor()} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Styled.PS.Chart>
    );
  }
}

export default view(DonutPMDecisionsPromotionalSpend);



// WEBPACK FOOTER //
// ./src/components/pm/decisions/charts/DonutPMDecisionsPromotionalSpend.js